import axios from '../../../axios/index.js'
import store from '../../../../store/store.js'
import router from '@/router'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default {
  init () {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // If response status is 401
      if (response && response.status === 401) {
        
        // Remove localStorage
        localStorage.removeItem('userInfo')
        localStorage.removeItem('accessToken')
    
        // Push to login page
        router.push({name: 'login'})
      }
      
      // if (status === 401) {
      // if (response && response.config.url !== '/api/v1/login') {
        // if (!isAlreadyFetchingAccessToken) {
        //   isAlreadyFetchingAccessToken = true
        //   store.dispatch('auth/fetchAccessToken')
        //     .then((access_token) => {
        //       isAlreadyFetchingAccessToken = false
        //       onAccessTokenFetched(access_token)
        //     })
        // }

      //   const retryOriginalRequest = new Promise((resolve) => {
      //     addSubscriber(access_token => {
      //       originalRequest.headers.Authorization = `Bearer ${access_token}`
      //       resolve(axios(originalRequest))
      //     })
      //   })
      //   return retryOriginalRequest
      // }

      return Promise.reject(error)
    })
  },
  login (username, pwd) {
    return axios.post('/api/v1/auth/login', {
      username,
      password: pwd
    })
  },
  registerUser (name, email, pwd) {
    return axios.post('/api/auth/auth/register', {
      displayName: name,
      email,
      password: pwd
    })
  },
  refreshToken () {
    return axios.post('/api/auth/refresh-token', {accessToken: localStorage.getItem('accessToKen')})
  }
}
